import {QuestionDifficulty} from '@domain/pom'

export const HIERARCHY_LEVELS = ['Global', 'Area', 'Region', 'Country', 'Plant'] as const
export type HierarchyLevel = (typeof HIERARCHY_LEVELS)[number]

export const CHART_VIEW_MODES = ['monthly', 'yearly'] as const
export type ChartViewMode = (typeof CHART_VIEW_MODES)[number]

export const DIFFICULTY_FILTER_ALL = 'all' as const
export type DifficultyFilter = typeof DIFFICULTY_FILTER_ALL | QuestionDifficulty
export const DIFFICULTY_FILTER_OPTIONS: DifficultyFilter[] = [
  DIFFICULTY_FILTER_ALL,
  QuestionDifficulty.Basic,
  QuestionDifficulty.Advanced,
  QuestionDifficulty.Excellence
]

export const VALUE_DISPLAY_MODES = ['total', 'percentage'] as const
export type ValueDisplayMode = (typeof VALUE_DISPLAY_MODES)[number]
